import { ContentDetailSummary } from '@raydiant/api-client-js';

export const colorsForContentDetailCharts = ['#FA8700', '#FADA5E'];
export const averageDataLineColor = '#8C8C8C';
export const iconForLegend =
  'path://M2,2 h16 a6,6 0 0 1 6,6 v16 a6,6 0 0 1 -6,6 h-16 a6,6 0 0 1 -6,-6 v-16 a6,6 0 0 1 6,-6 z';

export const ageGroups = [
  '0-12',
  '13-17',
  '18-24',
  '25-34',
  '35-44',
  '45-54',
  '55-64',
  '65+',
];

export const getViewingByDemographicData = (
  data: ContentDetailSummary | Partial<ContentDetailSummary>,
) => {
  const maleDistribution = {
    avg_viewing_duration_m0_12: Number(data.avg_viewing_duration_m0_12),
    avg_viewing_duration_m13_17: Number(data.avg_viewing_duration_m13_17),
    avg_viewing_duration_m18_24: Number(data.avg_viewing_duration_m18_24),
    avg_viewing_duration_m25_34: Number(data.avg_viewing_duration_m25_34),
    avg_viewing_duration_m35_44: Number(data.avg_viewing_duration_m35_44),
    avg_viewing_duration_m45_54: Number(data.avg_viewing_duration_m45_54),
    avg_viewing_duration_m55_64: Number(data.avg_viewing_duration_m55_64),
    avg_viewing_duration_m65_plus: Number(data.avg_viewing_duration_m65_plus),
  };

  const femaleDistribution = {
    avg_viewing_duration_f0_12: Number(data.avg_viewing_duration_f0_12),
    avg_viewing_duration_f13_17: Number(data.avg_viewing_duration_f13_17),
    avg_viewing_duration_f18_24: Number(data.avg_viewing_duration_f18_24),
    avg_viewing_duration_f25_34: Number(data.avg_viewing_duration_f25_34),
    avg_viewing_duration_f35_44: Number(data.avg_viewing_duration_f35_44),
    avg_viewing_duration_f45_54: Number(data.avg_viewing_duration_f45_54),
    avg_viewing_duration_f55_64: Number(data.avg_viewing_duration_f55_64),
    avg_viewing_duration_f65_plus: Number(data.avg_viewing_duration_f65_plus),
  };

  return {
    male: Object.values(maleDistribution),
    female: Object.values(femaleDistribution),
  };
};

export const getContentViewByDemographicData = (
  data: ContentDetailSummary | Partial<ContentDetailSummary>,
) => {
  const maleDistribution = {
    verified_views_m0_12_percentage: Number(
      data.verified_views_m0_12_percentage,
    ),
    verified_views_m13_17_percentage: Number(
      data.verified_views_m13_17_percentage,
    ),
    verified_views_m18_24_percentage: Number(
      data.verified_views_m18_24_percentage,
    ),
    verified_views_m25_34_percentage: Number(
      data.verified_views_m25_34_percentage,
    ),
    verified_views_m35_44_percentage: Number(
      data.verified_views_m35_44_percentage,
    ),
    verified_views_m45_54_percentage: Number(
      data.verified_views_m45_54_percentage,
    ),
    verified_views_m55_64_percentage: Number(
      data.verified_views_m55_64_percentage,
    ),
    verified_views_m65_plus_percentage: Number(
      data.verified_views_m65_plus_percentage,
    ),
  };

  const femaleDistribution = {
    verified_views_f0_12_percentage: Number(
      data.verified_views_f0_12_percentage,
    ),
    verified_views_f13_17_percentage: Number(
      data.verified_views_f13_17_percentage,
    ),
    verified_views_f18_24_percentage: Number(
      data.verified_views_f18_24_percentage,
    ),
    verified_views_f25_34_percentage: Number(
      data.verified_views_f25_34_percentage,
    ),
    verified_views_f35_44_percentage: Number(
      data.verified_views_f35_44_percentage,
    ),
    verified_views_f45_54_percentage: Number(
      data.verified_views_f45_54_percentage,
    ),
    verified_views_f55_64_percentage: Number(
      data.verified_views_f55_64_percentage,
    ),
    verified_views_f65_plus_percentage: Number(
      data.verified_views_f65_plus_percentage,
    ),
  };

  return {
    male: Object.values(maleDistribution),
    female: Object.values(femaleDistribution),
  };
};

export const getVerifiedViewRateData = (
  data: ContentDetailSummary | Partial<ContentDetailSummary>,
) => {
  const maleDistribution = {
    verified_view_rate_m0_12: Number(data.verified_view_rate_m0_12),
    verified_view_rate_m13_17: Number(data.verified_view_rate_m13_17),
    verified_view_rate_m18_24: Number(data.verified_view_rate_m18_24),
    verified_view_rate_m25_34: Number(data.verified_view_rate_m25_34),
    verified_view_rate_m35_44: Number(data.verified_view_rate_m35_44),
    verified_view_rate_m45_54: Number(data.verified_view_rate_m45_54),
    verified_view_rate_m55_64: Number(data.verified_view_rate_m55_64),
    verified_view_rate_m65_plus: Number(data.verified_view_rate_m65_plus),
  };

  const femaleDistribution = {
    verified_view_rate_f0_12: Number(data.verified_view_rate_f0_12),
    verified_view_rate_f13_17: Number(data.verified_view_rate_f13_17),
    verified_view_rate_f18_24: Number(data.verified_view_rate_f18_24),
    verified_view_rate_f25_34: Number(data.verified_view_rate_f25_34),
    verified_view_rate_f35_44: Number(data.verified_view_rate_f35_44),
    verified_view_rate_f45_54: Number(data.verified_view_rate_f45_54),
    verified_view_rate_f55_64: Number(data.verified_view_rate_f55_64),
    verified_view_rate_f65_plus: Number(data.verified_view_rate_f65_plus),
  };

  return {
    male: Object.values(maleDistribution),
    female: Object.values(femaleDistribution),
  };
};
